import { render } from "./StalledBets.vue?vue&type=template&id=0124087c&scoped=true&ts=true"
import script from "./StalledBets.vue?vue&type=script&lang=ts"
export * from "./StalledBets.vue?vue&type=script&lang=ts"

import "./StalledBets.vue?vue&type=style&index=0&id=0124087c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0124087c"]])

export default __exports__